import OnSaleOrRentList from './OnSaleOrRentList.container'

export default OnSaleOrRentList
